export default __webpack_public_path__ + "images/enter-cc-number.b003661e.svg";